<template>
  <div
    :style="{ backgroundImage: `url(${getCardUrl(card)})` }"
    class="w-16 mr-1 sm:w-16 md:w-20 lg:w-24 p-0 sm:p-2 md:p-3 lg:p-4 text-2xl font-bold border border-gray-200 rounded-md shadow-md bg-contain bg-white bg-center bg-no-repeat relative"
  >
    <span
      v-if="card.showingFace"
      class="absolute top-0 right-0 rounded-full h-6 w-6 flex items-center justify-center bg-blue-500 text-white text-base"
    >
      {{ card.hiLoValue == 1 ? "+1" : card.hiLoValue }}
    </span>
    <span class="block text-4xl font-bold text-center invisible"
      >{{ card.showingFace ? card.rank : "?" }}
    </span>
    <span
      class="py-2 font-light text-center invisible"
      v-if="card.showingFace"
      v-translatecard="card.suit"
    >
    </span>
  </div>
</template>

<script>
import store from "../store";
import { getCardCounterValue } from "../utils";

export default {
  data: function() {
    return {
      show: this.type === "dealer" ? true : false
    };
  },
  mounted() {
    if (this.type === "dealer") {
      this.$eventHub.$emit("dealerMountedCard");
    } else {
      this.$eventHub.$on("dealerMountedCard", () => {
        this.show = true;
      });
    }
  },

  methods: {
    getCardUrl: card => {
      return card.showingFace
        ? require("../assets/images/cards/" +
            card.rank +
            "_" +
            card.suit +
            ".svg")
        : require("../assets/images/cards/dealer-coperto.svg");
    }
  },
  name: "Card",
  props: ["card", "cardCounterValue", "type", "showForPlayer"],
  store
};
</script>



// WEBPACK FOOTER //
// src/components/Card.vue